(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const showMoreButton = document.querySelectorAll('.faq-button button')

    if (showMoreButton.length == 0) {
      return
    }

    showMoreButton[0].addEventListener('click', function () {
      const accordion = this.closest('.faq-block').querySelector('.faq-accordion')
      const hiddenQuestions = accordion.querySelectorAll('.faq-hidden')

      hiddenQuestions.forEach((question) => {
        question.style.display = ''
        question.classList.remove('faq-hidden')
      })

      this.remove()
    })
  })
  } catch(e) { console.error(e); }
})();

})();
